import languageSettings from '@/mixins/layouts/languageSettings'
import countrySettings from '@/mixins/layouts/countrySettings'
import accountDropdown from '@/mixins/layouts/accountDropdown'
import openPayments from '@/mixins/layouts/openPayments'
import authentication from '@/mixins/layouts/authentication'
import navbarSettings from '@/mixins/layouts/navbarSettings'
import reviews from '@/mixins/layouts/reviews'

export const authenticated = {
  mixins: [
    languageSettings,
    countrySettings,
    accountDropdown,
    openPayments,
    authentication,
    navbarSettings
  ]
}

export const unauthenticated = {
  mixins: [
    languageSettings,
    countrySettings,
    accountDropdown,
    navbarSettings,
    authentication,
    reviews
  ]
}
